const testimonials = [
  {
    name: "Átila Costa",
    role: "Voluntário",
    quote:
      "Participar da ação social do Instituto IESSA como barbeiro foi uma experiência marcante. Mais do que cortar cabelo, foi um momento de cuidado e partilha do amor de Deus por meio da pregação do evangelho. Ver a alegria no rosto de cada pessoa foi gratificante. Sou imensamente grato ao IESSA por essa iniciativa evangelística tão especial e transformadora.",
  },
  {
    name: "Edileide dos Anjos",
    role: "Aluna do Curso de Teologia",
    quote:
      "Fazer o curso de teologia com o Instituto IESSA foi uma verdadeira bênção. Sou evangélica desde criança, mas não compreendia bem as Escrituras. Muitas ideias eram apenas tradições ou mitos. Durante o curso, Deus esclareceu minha mente e hoje leio a Bíblia com uma nova visão. Foi uma experiência transformadora, pela qual agradeço a Deus, ao IESSA e a todos que tornaram esse projeto possível.",
  },
  {
    name: "Pr. Osmar Oliveira",
    role: "Pastor parceiro do IESSA",
    quote:
      "O trabalho do Instituto IESSA em Ponto Novo tem sido uma grande bênção. As ações de evangelismo e doações realizadas pelo IESSA e sua equipe têm alcançado muitas vidas. O Instituto está sempre pronto a servir e apoiar a comunidade. Somos gratos pela dedicação e pelo impacto espiritual desse ministério em nossa cidade.",
  },
];

const HomeTestimonials = () => {
  return (
    <section className="section-shell">
      <div className="mb-10 text-center">
        <p className="section-title">Depoimentos</p>
        <h2 className="section-heading">Vidas alcançadas e transformadas.</h2>
        <p className="section-subtitle mx-auto">
          Líderes, alunos e voluntários contam como têm experimentado o cuidado de Deus através do Instituto.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {testimonials.map((item) => (
          <article key={item.name} className="card-ambient hover-lift p-6 text-left">
            <p className="mb-4 text-sm text-muted-foreground">“{item.quote}”</p>
            <p className="text-sm font-semibold text-foreground">{item.name}</p>
            <p className="text-xs uppercase tracking-[0.18em] text-primary mt-1">{item.role}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HomeTestimonials;
